import React from 'react'
import styled from 'styled-components'

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  > div {
    min-width: ${props => (props.maxwidth ? props.maxwidth : 'none')};
    min-height: ${props => (props.maxheight ? props.maxheight : 'none')};
  }
  iframe {
    pointer-events: none;
  }
`

const Banner = ({ html, maxwidth, maxheight }) => (
  <BannerWrapper maxwidth={maxwidth} maxheight={maxheight}>
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}></div>
  </BannerWrapper>
)

export default Banner
